export default __webpack_public_path__ + "static/media/hotel_overseas_5.4643b613.jpeg";